import React, { Component } from 'react'
import styles from '../../styles/common/responseList.module.css'

export class ResponseListHeader extends Component {
    getHeader(){
        const { selection, responses  } = this.props;
        if(responses.filter((response) => response.id=== selection)[0]){            
            return responses.filter((response) => response.id=== selection)[0].title
        }else{
            return 'Response List'
        }
    }
    render() {
        const { listHeader, title } = styles;
        const { isOpen, toggleResponseList, featureId } = this.props;
        return (
            <div className={listHeader} onClick={() => toggleResponseList(featureId)}>
                <span className={title}>{this.getHeader()}</span>
                <i className={"material-icons"}>{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
            </div>
        )
    }
}


export default ResponseListHeader
